@if (!selectedDate) {
  <div>
    <h1 class="page-title">Daily Logs</h1>
    <!-- Reusable Date Range Picker Component -->
    <app-date-range-picker
      (datesGenerated)="onDatesGenerated($event)"
      [dateClass]="dateClass">
    </app-date-range-picker>
    <!-- Date Selection Buttons -->
    <div class="single-app-card">
      <app-card [title]="'Select Date to track emissions:'">
        <div class="date-selection-button-container">
          @for (date of displayedDates; track date) {
            <div>
              <button
                type="button"
                (click)="onDateSelected(date)"
                class="date-select-btn"
              [ngClass]="{
                'filled': hasEntries(date),
                'today': isToday(date),
                'in-group-time-period': isInGroupTimePeriod(date, groupMemberships),
                'disabled': isInFuture(date)
              }"
                [disabled]="isInFuture(date)"
              [matTooltip]="
                isInFuture(date)
                  ? 'Cannot select future dates'
                  : (date | date : 'dd.MM.yyyy')
              "
                [matTooltipPosition]="'above'"
                >
                <div class="date-display">
                  <span class="date-select-btn-day">{{ date | date: 'dd.' }}</span>
                  <span class="date-select-btn-month">{{ date | date: 'MMM' }}</span>
                </div>
              </button>
            </div>
          }
        </div>
      </app-card>
    </div>
  </div>
}


<!-- Activated Log entries when date is selected -->
@if (selectedDate) {
  <div>
    <h1 class="page-title">Log of {{ selectedDate | date:'dd.MM.yyyy' }}</h1>
    <button (click)="onBackToOverview()" class="btn"><app-icon name="arrow_left"/>Back to overview</button>
    <app-entry [selectedDate]="selectedDate"></app-entry>
  </div>
}

